export const basePalette = {
    contrastThreshold: 4.5,
    success: { main: "#0d8746", contrastText: "#ffffff" },
    error: { main: "#e02934", contrastText: "#ffffff" },
};

export default basePalette;
